import React from 'react'
import { IHorizonResource, HORIZON_STATE_COLORS } from '../types/operations.types'
import {
  HorizonRow,
  HorizonResourceName,
  HorizonTimeline,
  HorizonBlock,
} from '../styled/Operations.styled'

interface HorizonLaneProps {
  resource: IHorizonResource
}

export const HorizonLane: React.FC<HorizonLaneProps> = ({ resource }) => {
  return (
    <HorizonRow>
      <HorizonResourceName>{resource.name}</HorizonResourceName>
      <HorizonTimeline>
        {resource.tasks.map((task) => {
          const colors = HORIZON_STATE_COLORS[task.state]
          return (
            <HorizonBlock
              key={task.id}
              color={colors.bg}
              textColor={colors.text}
              flex={task.durationMinutes}
              blocked={task.state === 'blocked'}
              title={`${task.name} (${task.durationMinutes}m)`}
            >
              {task.name}
            </HorizonBlock>
          )
        })}
      </HorizonTimeline>
    </HorizonRow>
  )
}
